import React, { Children } from 'react';
import AdContainer from '../../../../../components/ads';

type Props = {
  children: JSX.Element[];
};

const MIN_ROW_TO_SHOW_AD = 10;
const advertSpacing = { bottom: '10px' };

export const ContainerAdsList = ({ children }: Props) => {
  const numOfRows = Children.count(children);
  const shouldShowAd = numOfRows >= MIN_ROW_TO_SHOW_AD;

  return (
    <>
      {Children.map(children, (child, index) => {
        if (!shouldShowAd) return child;
        if (![2, 8].includes(index)) return child;

        return index === 2 ? (
          <>
            <li>
              <AdContainer
                placement="dubbelpanorama1"
                format="panorama_1"
                min={0}
                max={860}
                spacing={advertSpacing}
              />
            </li>
            {child}
          </>
        ) : (
          <>
            <li>
              <AdContainer
                placement="dubbelpanorama2"
                format="panorama_2"
                min={0}
                max={860}
                spacing={advertSpacing}
              />
            </li>
            {child}
          </>
        );
      })}
    </>
  );
};
